<template>
    <b-modal
      id="confirmBox"
      hide-header
      centered
      no-close-on-backdrop
      body-class="confirm-modal-body"
      footer-class="confirm-modal-footer"
      v-model="show"
    >
      {{message}}
      <div
        class="p-0 m-0"
        slot="modal-footer"
      >
        <b-button
          @click="confirmAction"
          size="sm"
          class="confirm-btn-style"
        >
          OK
        </b-button>
        <b-button
          @click="cancelAction"
          class="ml-2 confirm-btn-style"
          size="sm"
        >
          Cancel
        </b-button>
      </div>
    </b-modal>
</template>
<script>
export default {
  name: 'ConfirmBox',
  props: {
    message: String,
    show: Boolean
  },
  methods: {
    confirmAction (event) {
      this.$emit('confirmed');
    },
    cancelAction (event) {
      this.$emit('cancel');
    }
  }
};
</script>
<style>
.modal-content {
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 60px !important;
  opacity: 1;
  width: 466px !important;
  height: 230px !important;
}
.confirm-modal-footer {
  border: none !important;
  justify-content: center !important;
  padding-top: 0px !important;
  padding-bottom: 26px !important;
}
.confirm-modal-body {
  margin: 45px auto;
  font-size: 20px;
  font-weight: bolder;
  max-height: 50px;
}
.confirm-btn-style {
  width: 181px;
  height: 50px;
  background: #339daa 0% 0% no-repeat padding-box;
  border-radius: 37px;
  opacity: 1;
  font-size: 15px;
}
@media only screen and (min-width: 375px) and (orientation: portrait) {
  .confirm-btn-style {
    width: 152px;
  }
}
</style>
